// extracted by mini-css-extract-plugin
export default {"textarea":"input-box_textarea__XyODp"};